import { Grid } from '@mui/material';
import FeedIcon from '@mui/icons-material/Feed';

import { useDetaileQuotation } from './hook';
import { QuotationProps } from './props';

import FieldText from '../../../../../components/general/fields/fieldText';
import { Accordion } from '../../../../../components/general/accordion';
import RichText from '../../../../../components/richText';

export const QuotationDetailGeneralInfo = ({ quotation }: QuotationProps) => {
    const { formik } = useDetaileQuotation(quotation);

    return (
        <Accordion
            title="INFORMACIÓN GENERAL"
            icon={<FeedIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={true}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Call ID:"
                        name="callId"
                        size="small"
                        value={formik.values.callId}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Canal:"
                        name="channel"
                        size="small"
                        value={formik.values.channel}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Tipo de cotización:"
                        name="typeQuotation"
                        size="small"
                        value={formik.values.typeQuotation}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Ramo:"
                        name="bouquet"
                        size="small"
                        value={formik.values.bouquet}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Tipificación:"
                        name="typification"
                        size="small"
                        value={formik.values.typification}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Subtipificación:"
                        name="subtypification"
                        size="small"
                        value={formik.values.subtypification}
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <RichText
                        initialContent={formik.values.body}
                        editable={false}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
